/**
 * Slider in text-content
 */
class ATS_SliderTextContent {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        let sliderWrappers = $('.block-slider-wrapper');

        if(sliderWrappers.length) {
            for (var i = 0; i < sliderWrappers.length; i++) {
                let wrapper = sliderWrappers.eq(i);
                let dot = sliderWrappers.eq(i).find('.slider-dot');
                let list = wrapper.find('.slider-list');
                let animationInProgress = false;
                let currentItem = 0;
    
                for (var j = 0; j < dot.length; j++) {            
                    dot.eq(j).on('click', e => {
                        e.preventDefault();
            
                        if (animationInProgress) {
                            return;
                        }
            
                        currentItem = parseInt($(e.target).attr('data-index'), 10);
                        animationInProgress = true;
                        dot.removeClass('is-active');
                        dot.eq(currentItem).addClass('is-active');
                        list.css('margin-left', (-100 * currentItem) + "%");
                        
                        setTimeout(function() {
                            animationInProgress = false;
                        }, 550);
                    });
                }
            }
        }
    }
}